export default "__VITE_ASSET__B9OS2Dw3__"